import React, { useEffect, useState } from "react";
import { collection, query, where, onSnapshot } from "firebase/firestore";
import { db } from "../firebase";
import { getAuth } from "firebase/auth";
import "./Analiticas.css";

// Devuelve el lunes de la semana de una fecha
function getMonday(d) {
  d = new Date(d);
  const day = d.getDay();
  const diff = d.getDate() - ((day + 6) % 7);
  return new Date(d.setDate(diff));
}

// Devuelve un array con las fechas (YYYY-MM-DD) de la semana actual (Lunes a Domingo) en hora local
function getCurrentWeekDates(monday) {
  const week = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(monday);
    date.setDate(monday.getDate() + i);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    week.push(`${year}-${month}-${day}`);
  }
  return week;
}

const dias = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

const Analiticas = () => {
  const [monday, setMonday] = useState(getMonday(new Date()));
  const weekDates = getCurrentWeekDates(monday);
  const [data, setData] = useState({}); // { fecha: {completadas, noCompletadas} }

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return; // si no hay usuario logueado, no hacemos nada

    const q = query(
      collection(db, "scheduledTasks"),
      where("userId", "==", user.uid), // 🔹 filtro por usuario
      where("date", ">=", weekDates[0]),
      where("date", "<=", weekDates[6])
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const weekData = {};
      weekDates.forEach(date => {
        weekData[date] = { completadas: 0, noCompletadas: 0 };
      });
      snapshot.forEach(doc => {
        const task = doc.data();
        let fecha = task.date;

        if (fecha && typeof fecha.toDate === "function") {
          const d = fecha.toDate();
          const year = d.getFullYear();
          const month = String(d.getMonth() + 1).padStart(2, "0");
          const day = String(d.getDate()).padStart(2, "0");
          fecha = `${year}-${month}-${day}`;
        }

        if (weekData[fecha]) {
          if (task.completed) weekData[fecha].completadas += 1;
          else weekData[fecha].noCompletadas += 1;
        }
      });
      setData(weekData);
    });

    return () => unsubscribe();
  }, [weekDates]);

  // Busca el máximo de tareas en un día para escalar las barras
  const maxTareas = Math.max(
    ...weekDates.map(
      d =>
        (data[d]?.completadas || 0) +
        (data[d]?.noCompletadas || 0)
    ),
    1
  );

  return (
    <div className="analiticas-container">
      <h2>Analítica de la Semana</h2>
      <div style={{ display: "flex", justifyContent: "center", gap: 16, marginBottom: 16 }}>
        <button
          className="analiticas-btn"
          onClick={() => setMonday(prev => {
            const d = new Date(prev);
            d.setDate(d.getDate() - 7);
            return getMonday(d);
          })}
        >
          Semana anterior
        </button>
        <button
          className="analiticas-btn"
          onClick={() => setMonday(getMonday(new Date()))}
        >
          Semana actual
        </button>
        <button
          className="analiticas-btn"
          onClick={() => setMonday(prev => {
            const d = new Date(prev);
            d.setDate(d.getDate() + 7);
            return getMonday(d);
          })}
        >
          Semana siguiente
        </button>
      </div>
      <div className="barras-verticales">
        {weekDates.map((date, idx) => {
          const completadas = data[date]?.completadas || 0;
          const noCompletadas = data[date]?.noCompletadas || 0;
          const completadasPct = (completadas / maxTareas) * 100;
          const noCompletadasPct = (noCompletadas / maxTareas) * 100;
          return (
            <div className="columna-semana" key={date}>
              <div className="barra-vertical">
                <div
                  className="barra-no-completadas-vert"
                  style={{ height: `${noCompletadasPct}%` }}
                  title={`${noCompletadas} no completadas`}
                />
                <div
                  className="barra-completadas-vert"
                  style={{ height: `${completadasPct}%` }}
                  title={`${completadas} completadas`}
                />
              </div>
              <div className="barra-valores-vert">
                <span className="verde">{completadas}</span>/
                <span className="rojo">{noCompletadas}</span>
              </div>
              <div className="semana-label-vert">{dias[idx]}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Analiticas;
